import React from 'react';
import { getTickConflicts } from '../lib/eventCompleteness';

/**
 * "Music booking only" tick (Oct 2026). When ticked the event has no required
 * fields: it is never orange/red, can be saved inside 7 days with gaps, and
 * gets no reception "complete details" task. See lib/eventCompleteness.js.
 */
export default function MusicOnlyToggle({ data, onChange, className = '' }) {
  const checked = !!data?.musicOnly;
  const tc = checked ? getTickConflicts(data) : { strong: [], soft: [] };
  const warn = [...tc.strong, ...tc.soft].filter((t) => t.startsWith('"Music booking only"'));
  const nonMusicType = checked && data?.type && data.type !== 'music_night';
  const toggle = (e) => onChange({ target: { name: 'musicOnly', value: e.target.checked, checked: e.target.checked, type: 'checkbox' } });
  return (<>
    <label className={`flex items-start gap-2 px-3 py-2 rounded-lg border text-sm cursor-pointer ${checked ? 'border-violet-300 bg-violet-50 text-violet-900' : 'border-slate-200 bg-slate-50 text-slate-700'} ${className}`}>
      <input type="checkbox" checked={checked} onChange={toggle} className="mt-0.5" />
      <span>
        <span className="font-semibold">Music booking only</span>
        <span className="block text-xs text-slate-500">No food or setup details needed – skips required fields and the orange/red lists.</span>
      </span>
    </label>
    {(warn.length > 0 || nonMusicType) && (
      <div className={`-mt-2 mb-4 rounded-lg border border-amber-400 bg-amber-50 px-3 py-2 text-xs text-amber-900`}>
        <b>Check this:</b> {[...warn, ...(nonMusicType ? ['this booking is not a Music Night type'] : [])].join('; ')}.
        {' '}Music-only bookings appear on the daily sheet and kitchen as one small line, not as a function. Untick it if this is a real function.
      </div>
    )}
  </>);
}
